var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-header"},[_vm._v(" This is some header. Not sure if we need it ")])}
var staticRenderFns = []

export { render, staticRenderFns }